import { render } from "./DateSignatureSection.vue?vue&type=template&id=70bb5158&scoped=true&ts=true"
import script from "./DateSignatureSection.vue?vue&type=script&lang=ts"
export * from "./DateSignatureSection.vue?vue&type=script&lang=ts"

import "./DateSignatureSection.vue?vue&type=style&index=0&id=70bb5158&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70bb5158"]])

export default __exports__